import {Worker, Viewer} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const PDFPreview = ({fileUrl, style, defaultScale = 0.5}) => {
  return (
    <div
      className="pdfPreviewWrapper"
      style={style}
    >
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
        <Viewer
          fileUrl={fileUrl}
          defaultScale={defaultScale}
        />
      </Worker>
    </div>
  );
};

export default PDFPreview;
